import { SvgIcon } from '@mui/material';

export function ESignRequiredFieldMarker() {
  return (
    <SvgIcon
      aria-hidden
      data-esign-required-field-marker="true"
      viewBox="0 0 12 12"
      sx={(theme) => ({
        bottom: 2,
        color: theme.palette.error.main,
        filter: `drop-shadow(0 0 1px ${theme.palette.background.paper})`,
        fontSize: 12,
        pointerEvents: 'none',
        position: 'absolute',
        right: 4,
        zIndex: 1
      })}
    >
      <path
        d="M6 1.5v9M2.1 3.75l7.8 4.5M9.9 3.75l-7.8 4.5"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeWidth="1.8"
      />
    </SvgIcon>
  );
}
